export var getConfigBotones = function getConfigBotones(state) {
  return state.configBotones;
};